<template>
  <div id="app">
    <Headers></Headers>
    <div class="center">
      <!-- 用户服务 -->
      <div class="h1"></div>
      <div class="h2">
        <div class="w">
          <el-tabs
            class="animate__animated animate__fadeInUpBig"
            :tab-position="tabPosition"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane label="投资者管理办法">
              <div class="lis">
                <div class="box"></div>
                <h2>投资者管理办法</h2>
              </div>
              <h4>第一章 总则</h4>
              <p>第一条 目的和依据</p>
              <p>
                为落实北京天相财富管理顾问有限公司(以下简称“公司”)投资者适当性管理，维护投资者合法权益，《证券法》、《证券公司监督管理条例》、《证券期货投资者适当性管理办法》(以下简称《办法》)及其他相关法律、行政法规和中国证监会规定,制定本办法。
              </p>
              <p>第二条 适用范围</p>
              <p>
                公司及其分公司向投资者销售产品，或者为投资者提供相关服务的(以下统称“产品”或者“服务”)，应遵守法律法规、监管规定、自律规则及本办法的规定。
              </p>
              <p>第三条 基本要求</p>
              <p>
                公司及其从业人员在销售产品或者提供服务过程中，应当按照本办法的规定，勤勉尽责，审慎履职，全面了解投资者情况，深入调查分析产品或者服务信息，科学有效评估，充分揭示风险，基于投资者的不同风险承受能力以及产品或者服务的不同风险等级，提出明确的适当性匹配意见，将适当的产品或者服务销售或者提供给适合的投资者，并对违法违规行为承担法律责任。
              </p>
              <h4>第二章 组织架构与职责</h4>
              <p>第四条 投资者适当性管理工作组织</p>
              <p>
                公司成立投资者适当性管理的工作组，负责投资者适当性管理工作。
              </p>
              <p>第五条 产品与服务适当性风险评估工作</p>
              <p>
                工作组负责制定本机构产品或者服务风险分级的标准、方法和流程，对具体产品或者服务进行风险评估与风险评级，制定本机构的产品和服务风险等级名录，并适时根据监管要求和具体产品或服务的变化调整产品和服务的分级。
              </p>
              <p>第六条 业务部门职责</p>
              <p>
                相关业务部门是落实投资者适当性管理工作的首要部门。其负责的工作内容包括但不限于了解投资者各项信息并收集相关证明材料、进行投资者分类、分级，根据投资者的风险承受能力对每名投资者提出匹配意见等。
              </p>
              <p>第七条 合规部</p>
              <p>
                合规部根据法律法规、监管规定和自律规则制定本机构适当性内部管理制度，进行相关培训，督促相关部门落实投资者适当性管理工作，组织开展本机构的适当性自查，对本机构销售产品或者提供服务的相关业务进行审核，处理因投资者适当性产生的纠纷。
              </p>
              <h4>第三章 投资者分类和分级</h4>
              <p>第八条 了解投资者信息</p>
              <p>
                本公司在向投资者销售产品或提供服务时，应当了解投资者的下列信息
              </p>
              <p>(一)自然人的姓名、住址、职业、年龄、联系方式等基本信息；</p>
              <p>(二)收入来源和数额、资产、债务等财务状况；</p>
              <p>(三)投资相关的学习、工作经历及投资经验；</p>
              <p>(四)投资期限、品种、期望收益等投资目标；</p>
              <p>(五)风险偏好及可承受的损失；</p>
              <p>(六)诚信记录；</p>
              <p>(七)实际控制投资者的自然人和交易的实际受益人；</p>
              <p>(八)法律法规、自律规则规定的投资者准入要求相关信息；</p>
              <p>(九)其他必要信息。</p>
              <p>第九条 信息真实</p>
              <p>
                公司应当要求投资者对其提供的信息和证明材料的真实性、准确性、完整性负责，并配合本机构进行适当性评估、分类及匹配管理；投资者提供的信息发生重要变化，可能影响其投资者分类的，本机应当要求投资者及时告知本机构。
              </p>
              <p>
                投资者不按照规定提供相关信息，提供信息不真实、不准确、不完整的，应当依法承担相应法律责任，本公司应当告知其后果，并拒绝向其销售产品或者提供服务。
              </p>
              <p>第十条 投资者类型</p>
              <p>
                公司实施投资者差异化适当性管理。对投资者在信息告知、风险警示、适当性匹配等方面提供分析。
              </p>
              <p>
                投资者按照其风险承受能力由低到高划分为：C1保守型(含风险承受能力最低类别)、C2谨慎型、C3稳健型、C4积极型和C5激进型。
              </p>
              <p>第十一条 投资者评估问卷</p>
              <p>
                公司制作投资者风险承受能力评估问卷以了解投资者风险承受能力情况。问卷内容应当包括收入来源和数额、资产状况、债务、投资知识和经验、风险偏好、诚信状况等因素；问卷应当根据评估选项与风险承受能力的相关性，合理设定选项的分值和权重，建立评估得分与风险承受能力等级的对应关系。
              </p>
              <p>
                公司应当根据了解的投资者信息，结合问卷评估结果，对其风险承受能力进行综合评估。公司及相关人员在投资者填写风险承受能力评估问卷时，不得进行诱导、误导、欺骗投资者，影响填写结果。
              </p>
              <p>
                投资顾问部要根据投资者信息表、风险测评问卷以及其他相关材料，对投资者身份信息进行核查，对风险等级进行综合评估，并在收到投资者提供的信息表、风险测评问卷以及其他相关材料之日起5个工作日内，将投资者类型以及风险等级评估结果告知投资者。
              </p>
              <p>第十二条 风险承受能力最低类别投资者</p>
              <p>
                C1类投资者同时符合以下条件之一的，应当将其认定为风险承受能力最低类别的投资者：
              </p>
              <p>(一)不具有完全民事行为能力；</p>
              <p>(二)没有风险容忍度或者不愿承受任何投资损失；</p>
              <p>(三)其他情形。</p>
              <p>
                认定为风险承受能力最低类别投资者主动购买与之风险承受能力不匹配的产品或者服务的，需要符合本办法和相关法律法规、监管规定、自律规则的要求。
              </p>
              <p>第十三条 《投资者风险承受能力评估问卷》</p>
              <p>
                公司应当根据普通投资者信息,通过投资者填写《投资者风险承受能力评估问卷》等方法对其风险承受能力进行综合评估。《投资者风险承受能力评估问卷》的设计应当科学、合理、全面、通俗易懂。
              </p>
              <p>第十四条 投资者分类基本要求</p>
              <p>
                公司应当按照本办法要求进行投资者分类和分级，并对投资者就分类分级的结果、依据和理由履行告知义务。公司应当与普通投资者确认其风险承受能力等级结果,并以书面方式记载留存。
              </p>
              <p>
                《投资者基本信息表》、《投资者风险承受能力评估问卷》应当由投资者本人或合法授权人填写。公司及其工作人员不得以明示、暗示等方式诱导、误导、欺骗投资者,影响填写结果。
              </p>
              <p>第十五条 后续评估及调整</p>
              <p>司应当至少每两年对普通投资者风险承受能力进行一次后续评估。</p>
              <p>
                公司调整投资者风险承受能力等级的，应当以书面形式将风险承受能力评估结果告知投资者。
              </p>
              <h4>第四章 产品或者服务分级</h4>
              <p>第十四条 议事规则</p>
              <p>工作委员会评估表决产品或者服务的风险等级。</p>
              <p>
                工作委员会会议每次须由至少3名成员参加，评估表决实行一人一票制，获得2以上(含)成员同意视为通过，不同意见应当记录在案。表决结果(含产品风险评级内容)以书面或电子文档形式留档保存。
              </p>
              <p>第十五条 产品或者服务的评审方式</p>
              <p>工作委员会应当制定产品或服务分级的标准、方法和流程</p>
              <p>第十六条 产品或者服务风险等级划分</p>
              <p>
                本公司产品或者服务按照其风险等级由低到高划分为五级：R1、R2、R3、R4、R5。
              </p>
              <p>第十八条 划分风险等级调查信息</p>
              <p>
                充分了解、更新本公司的诚信状况、经营管理能力、投资管理能力、内部控制情况、合法合规情况以及产品或者服务的合法合规情况、投资组合品种、投资策略和投资限制概况，过往业绩比较、收益与风险的匹配情况，投资者承担的主要费用及费率、购买方式等相关信息。
              </p>
              <p>第十九条 划分风险等级考虑因素</p>
              <p>
                划分风险等级时，应充分考虑以下两方面因素：(一)本公司成立时间、治理结构、客户资本金规模、软件功能、研发团队稳定性、资产配置能力、内部控制制度健全性及执行度、风险控制完备性、是否有风险应对措施、从业人员合规性、股东、高级管理人员及投顾老师的稳定性等；(二)产品或者服务的结构、投资服务方式、投资服务范围和资金配置比例、服务期限、过往业绩、成立以来有无违规行为发生等。
              </p>
              <p>
                根据产品或者服务的评估因素与风险等级的相关性，确定各项评估因素的分值和权重。涉及组合产品或者投资建议服务，应当按照产品或者服务整体风险等级进行评估。
              </p>
              <p>第二十条 产品或者服务的准入条件</p>
              <p>公司应当审慎审核投资者是否存在以下不符合准入条件的情形：</p>
              <p>(一)不具有完全民事行为能力；</p>
              <p>(二)不具备证券期货投资知识或者金融投资经验；</p>
              <p>(三)其他情形；</p>
              <p>本公司不得向存在以上情形的投资者销售产品或者提供服务。</p>
              <p>第二十一条 委托其他机构销售的义务</p>
              <p>
                公司委托其他机构销售本公司发行的产品或者提供服务，应当审慎选择受托方，确认受托方具备代销相关产品或者提供服务的资格和落实相应适当性义务要求的能力，应当制定并告知代销方所委托产品或者提供服务的适当性管理标准和要求，代销方应当严格执行，但法律、行政法规、中国证监会其他规章另有规定的除外。
              </p>
              <p>第二十二条 委托销售合同</p>
              <p>
                除法律法规另有规定外，委托销售产品或提供服务，或受托销售产品或提供服务，对双方的权利义务、适当性管理的适用标准以及相关法律责任的承担，均应当在相关委托协议中予以明确约定。
              </p>
              <h4>第五章 适当性匹配与管理</h4>
              <p>第二十三条 适当性匹配原则</p>
              <p>
                本公司按照“适当的产品(服务)销售给适当的投资者”的原则销售产品或者提供服务。应当遵守下列匹配要求：
              </p>
              <p>
                (一)产品使用期限、投资建议品种、期望收益等符合投资者的投资目标；
              </p>
              <p>
                (二)产品或者服务的风险等级符合普通投资者的风险承受能力等级；
              </p>
              <p>
                (三)公司对投资者提出的适当性匹配意见不代表其对产品或服务的风险和收益作出实质性判断或保证。投资者在参考本公司适当性匹配意见的基础上,根据自身能力审慎独立决策,独立承担投资风险。
              </p>
              <p>(四)其他匹配要求。</p>
              <p>第二十四条 适当性匹配标准</p>
              <p>适当性匹配按照下表标准。</p>
              <img src="../assets/img/userService/h2-1.png" alt="" />
              <p>第二十五条 适当性不匹配的处理</p>
              <p>
                风险承受能力最低类别以外的普通投资者主动要求购买或接受高于其风险承受能力评估等级的产品或者服务的，公司在确认其不属于风险承受能力最低类别投资者后，应当就产品或者服务高于其承受能力进行特别的书面风险警示，投资者仍坚持购买的，可以向其销售相关产品或者提供相关服务，其具体程序如下：
              </p>
              <p>
                (一)普通投资者主动向本公司提出申请，明确表示要求购买具体的、高于其风险承受能力的产品或服务，并同时声明，本公司及其工作人员没有在销售过程中主动推介该产品或服务的信息；
              </p>
              <p>
                (二)本公司对普通投资者资格进行审核，确认其不属于风险承受能力最低类别投资者，也没有违反投资者准入性规定；
              </p>
              <p>
                (三)本公司向普通投资者以纸质或电子文档的方式进行特别警示，告知其该产品或服务风险高于投资者承受能力；
              </p>
              <p>
                (四)普通投资者对该警示进行确认，表示已充分知晓该产品或者服务风险高于其承受能力，并明确做出愿意自行承担相应不利结果的意思表示；
              </p>
              <p>
                (五)本公司履行特别警示义务后，普通投资者仍坚持购买该产品或者服务的，本公司可以向其销售相关产品或者提供相关服务。
              </p>
              <p>
                产品的使用期限、投资建议品种与普通投资者拟使用期限、投资建议品种不匹配的，应当以书面方式向投资者进行提示。
              </p>
              <p>第二十六条 对投资者的告知义务</p>
              <p>
                公司向投资者销售产品或者提供服务前，应当告知可能的风险事项及明确的适当性匹配意见，包括：
              </p>
              <p>(一)可能直接导致本金亏损的事项；</p>
              <p>(二)可能直接导致超过原始本金损失的事项；</p>
              <p>
                (三)因本公司业务或者人员变动，可能导致本金或者原始本金亏损的事项；
              </p>
              <p>(四)因本公司业务或者人员变动，影响客户判断的重要事由；</p>
              <p>
                (五)限制销售对象权利行使期限或者可解除合同期限等全部限制内容；
              </p>
              <p>(六)按照本办法出具的适当性匹配意见。</p>
              <p>第二十七条 独立决策并承担风险的告知业务</p>
              <p>
                公司应当告知投资者，应综合考虑自身风险承受能力与本机构的适当匹配意见，独立做出投资决策并承担投资风险。
              </p>
              <p>
                适当性匹配意见不表明本机构对产品或者服务的风险和收益做出实质性判断或者保证，本机构履行投资者适当性职责不能取代投资者的投资判断，不会降低产品或者服务的固有风险，也不会影响其依法承担的投资风险、责任及费用。
              </p>
              <p>第二十八条 向投资者销售高风险产品特别注意义务</p>
              <p>
                公司向普通投资者销售风险等级高于普通投资者风险承受能力等级的产品或者提供相关服务，应当履行特别注意义务，包括制定专门的工作程序，追加了解相关信息，告知特别风险点，给予普通投资者更多的考虑时间，或增加回访频次等。
              </p>
              <p>
                本公司在向普通投资者销售R5风险等级的产品或者服务时，应向其完整揭示以下事项：
              </p>
              <p>(一)产品或者服务的详细信息、重点特性和风险；</p>
              <p>
                (二)产品或者服务的主要费用、费率及重要权利、信息披露内容、方式及频率
              </p>
              <p>(三)普通投资者可能承担的损失；</p>
              <p>(四)普通投资者投诉方式及纠纷解决安排。</p>
              <p>第二十九条 信息变化</p>
              <p>
                公司应当根据投资者和产品或者服务的信息变化情况，主动调整投资者分类、产品或者服务分级以及适当性匹配意见，并履行相应的告知义务。
              </p>
              <p>第三十条 禁止违规匹配</p>
              <p>公司不得进行下列销售产品或提供服务的活动：</p>
              <p>(一)向不符合准入要求的投资者销售产品或者提供服务；</p>
              <p>
                (二)向投资者就不确定事项提供确定性判断，或者告知投资者有可能使其误认为具有确定性的意见；
              </p>
              <p>
                (三)向投资者主动推介风险等级高于其风险承受能力的产品或者服务
              </p>
              <p>(四)向投资者主动推介不符合其投资目标的产品或者服务；</p>
              <p>
                (五)向风险承受能力最低类别的投资者销售或者提供R1风险等级以外的产品或者服务；
              </p>
              <p>(六)其他违背适当性要求，损害投资者合法权益的行为。</p>
              <p>
                公司认为投资者购买产品或者接受服务不适当或者无法判断是否适当的，不得主动向客户推介。
              </p>
              <p>第三十一条 告知、警示要求</p>
              <p>
                公司对投资者进行告知、警示，内容应当真实、准确、完整，不存在虚假记载、误导性陈述或重大遗漏，语言应当通俗易懂；告知、警示应当采用书面形式送达投资者，并由其确认已充分理解和接受，并留痕。
              </p>
              <h4>第六章 适当性保障与监督</h4>
              <p>第三十二条 适当性留痕要求</p>
              <p>
                向投资者销售高风险产品或者服务，调整投资者分类、产品或者服务分级以及适当性匹配意见，向投资者销售产品或者服务前对其进行风险提示的环节，公司应当进行全过程录音或录像；通过互联网等非现场方式进行的，应完善信息管理平台留痕功能，由普通投资者通过电子方式进行确认，并完整记录投资者确认信息。
              </p>
              <p>第三十三条 评估与销售隔离</p>
              <p>
                公司销售人员不得参与投资者的分类评估、产品与服务的分级评估，以及投资者与产品服务的匹配。
              </p>
              <p>第三十四条 适当性回访要求</p>
              <p>
                公司建立健全投资者回访制度,对购买产品或接受服务的投资者,每年抽取不低于上一年度末购买产品或接受服务的投资者总数(含购买或者接受产品或服务的风险等级高于其风险承受能力的投资者,不含未成单账户及中止合作的投资者)的10%进行回访。回访的内容包括但不限于:
              </p>
              <p>(一)受访人是否为投资者本人;</p>
              <p>
                (二)受访人是否按规定填写了《投资者基本信息表》、《投资者风险承受能力评估问卷》等并按要求签署;
              </p>
              <p>(三)受访人是否已知晓产品或服务的风险以及相关风险警示；</p>
              <p>(四)受访人是否已知晓所购买产品或接受服务的业务规则；</p>
              <p>
                (五)受访人是否已知晓自己的风险承受能力等级、购买的产品或>者接受服务的风险等级以及适当性匹配意见；
              </p>
              <p>(六)受访人是否知晓承担的费用以及可能产生的投资损失；</p>
              <p>(七)工作人员是否存在《办法》第二十二条规定的禁止行为。</p>
              <p>第三十五条 适当性培训</p>
              <p>
                公司定期组织适当性管理培训。培训内容应当包括相关法律法规及本公司制度、产品或者服务的结构、风险特征、投资者信息采集、投资者风险披露与提示等。
              </p>
              <p>第三十六条 适当性自查</p>
              <p>
                公司应当定期组织开展适当性自查，并形成自查报告。适当性自查报告的内容包括适当性制度建设、人员考核与培训、适当性评估与匹配、数据资料保管、投资者投诉处理、业务风险与整改情况以及其他需要报告的事项。
              </p>
              <p>
                本公司发现违反适当性管理要求的，应当及时处理并主动向监管机构与行业协会报告。
              </p>
              <p>第三十七条 监督问责</p>
              <p>
                本公司不得采取鼓励不适当销售的考核激励措施，确保从业人员切实履行适当性义务。
              </p>
              <p>
                从业人员在经营管理中不遵守投资者适当性管理要求，或违反投资者适当性管理义务，造成潜在合规风险或给本机构造成损失的，公司有权进行处分，或移送有关机关处理。涉及员工违规违纪的，按照本公司相关用工制度规范处理。
              </p>
              <p>第三十八条 披露规定</p>
              <p>
                公司应当向投资者披露本机构的适当性管理办法；本公司有权决定是否通过网站、经营场所等披露投资者分类政策、产品或者服务分类政策和自查报告等。
              </p>
              <p>第三十九条 信息保密及保存</p>
              <p>
                公司及从业人员应对履行适当性管理工作职责过程中获取的投资者信息、风险承受能力评估结果等信息和资料予以保密，防止该等信息和资料被泄露或不当利用。
              </p>
              <p>
                公司应妥善保存其收集的投资者信息和资料，对适当性管理制度、投资者资料、告知警示资料、录音录像资料、自查报告等的保存期限不少于20年。
              </p>
              <p>第四十条 投诉和纠纷的处理</p>
              <p>
                相关业务部门因履行投资者适当性职责引起投资者投诉或纠纷的，应准确记录投资者的投诉内容，并上报，公司尽快与投资者取得联系，友好协商解决争议。
              </p>
              <h4>第七章 附则</h4>
              <p>第四十一条 用词释义</p>
              <p>本办法所称书面形式包括纸质或者电子形式。</p>
              <p>第四十二条 实施时间</p>
              <p>本办法自发布之日起实施。</p>
            </el-tab-pane>
            <el-tab-pane label="风险揭示书">
              <div class="lis">
                <div class="box"></div>
                <h2>风险揭示书</h2>
              </div>
              <h4>尊敬的投资者：</h4>
              <p>
                当您投资证券市场的时候，可能获得较高的投资收益，但同时也存在着较大的投资风险。为了使您充分了解证券投资顾问业务的风险，根据《证券投资顾问业务暂行规定》、《证券投资顾问业务风险提示书必备条款》、《证券、期货投资者适当性管理办法》等有关法律、行政规章和行业自律规则的规定，请您在接受北京天相财富管理顾问有限公司（以下简称“我公司”）证券投资顾问服务前，认真阅读以下内容：
              </p>
              <p>
                第一条
                在接受证券投资顾问服务前，您已充分了解我公司具备证券投资咨询业务资格（证券投资咨询业务资格证书编号：91110102MA001GJE1N
                ），我公司提供服务的人员具备证券投资咨询执业资格并已经注册登记为证券投资顾问。有关信息可在中国证券业协会网站（www.sac.net.cn）查询确认。
              </p>
              <p>
                第二条
                证券投资顾问业务，是证券投资咨询业务的一种基本形式，指证券公司、证券投资咨询机构接受客户委托，按照约定，向客户提供涉及证券以及证券相关产品的投资建议服务，辅助客户做出投资决策，并直接或者间接获取经济利益的经营活动。投资建议服务内容包括投资的品种选择、投资组合以及理财规划建议等。
              </p>
              <p>
                您已充分了解证券投资顾问业务的含义，理解了接受证券投资顾问服务后需自主做出投资决策并独立承担投资风险。
              </p>
              <p>
                第三条
                您已充分了解我公司及我公司人员提供的软件产品不能确保您获得盈利或本金不受损失。
              </p>
              <p>
                第四条
                您已充分了解证券投资咨询机构及其人员提供的投资建议具有针对性和时效性，不能在任何市场环境下长期有效。
              </p>
              <p>
                第五条
                您已充分了解作为投资建议依据的证券研究报告和投资分析意见等，可能存在不准确、不全面或者被误读的风险，投资者您可以向证券投资顾问了解证券研究报告的发布人和发布时间以及投资分析意见的来源，以便在进行投资决策时作出理性判断。
              </p>
              <p>
                第六条
                您已充分了解我公司证券投资顾问服务的收费标准和方式，按照公平、合理、自愿的原则与我公司协商并书面约定收取证券投资顾问服务费用的安排。证券投资顾问服务收费应向我公司的公司账户支付，不得向证券投资顾问人员或其他个人账户支付。
              </p>
              <p>
                第七条
                您已充分了解我公司及其人员可能存在道德风险，如您发现投资顾问存在违法违规行为或利益冲突情形，比如泄露客户投资决策计划、传播虚假信息、进行关联交易等，您可以向我公司投诉或向有关部门举报。
              </p>
              <p>
                第八条
                您已充分了解我公司存在因停业、解散、撤销、破产，或者被中国证监会撤销相关业务许可、责令停业整顿等原因导致不能履行职责的风险。
              </p>
              <p>
                第九条
                您已充分了解我公司的投资顾问人员存在因离职、离岗等原因导致更换证券投资顾问服务人员并影响服务连续性的风险。
              </p>
              <p>
                第十条
                您已向我公司说明自身资产与收入状况、投资经验、投资需求和风险偏好等情况并接受评估，以便我公司根据您的风险承受能力和服务需求，向您提供适当的证券投资顾问服务。您应当在了解产品或者服务情况，听取适当性匹配意见的基础上，根据自身能力审慎决策，独立承担投资风险。我公司的适当性匹配意见不表明对产品或者服务的风险和收益作出实质性判断或者保证。若您的登记信息发生重要变化，务必及时告知公司。如果您不按照规定提供信息，或提供信息不真实、不准确、不完整的，应当依法承担相应的法律责任。
              </p>
              <p>
                第十一条
                您已向我公司提供有效的联系方式，如有变动须及时向我公司进行说明，如因您自身原因或不可抗力因素导致未能及时获取证券投资顾问服务，责任将由您自行承担。
              </p>
              <p>
                第十二条
                在接受证券投资顾问服务时，您应保管好自己的证券账户、资金账户和相应的密码，不要委托证券投资顾问人员管理您的证券账户、资金账户，代理买卖证券，否则由此导致的风险将由您自行承担。
              </p>
              <p>
                第十三条
                我公司以软件工具、终端设备或者视频直播、官方网站等为载体，向您提供投资建议及类似功能服务，或者教学课程、教学课件等服务，您在接受并使用该软件工具、终端设备、教学课程等之前，必须仔细阅读相关说明介绍，了解其实际功能、信息来源、固有缺陷和使用风险，由于您自身原因导致该软件工具、终端设备、教学课程等使用不当或受到病毒入侵、黑客攻击等不良影响的，由此导致的风险将由您自行承担。
              </p>
              <p>
                第十四条
                该软件工具、终端设备具有选择证券投资品种或者提示买卖时机功能的，您应充分了解其方法和局限，并应当知晓证券投资品种选择或买卖时机提示等功能会因电脑技术水平、数据统计及分析逻辑甚至第三方软件功能等因素受到限制。该选择与提示功能只能供您参考，不能作为您的投资决策依据。
              </p>
              <p>
                第十五条
                公司发布的教学课程包含直播教学视频及教学材料，仅供该产品学员使用，我公司不会因为其他任何机构或个人接收到本教学课程而视其为本公司学员。教学课程基于已正式公开的行情、资料或信息进行教学，但我公司不保证该信息及资料的完整性、准确性、时效性。教学课程所载的信息、资料、建议及推测仅反映授课老师于发布当时的判断，不代表将来的趋势，教学课程中的证券或投资标的价格、价值及投资带来的结果，只能供您参考，不能作为您的投资决策依据。
              </p>
              <p>第十六条 北京天相财富管理顾问有限公司基本信息</p>
              <p>1.公司注册地址：北京市西城区金融街19号B701D室</p>
              <p>2.客户服务电话：010-66045050</p>
              <p>3.客户投诉电话：400-101-8662</p>
              <p>4.经营证券期货业务许可证号码：91110102MA001GJE1N</p>
              <p>5.公司网站：https://www.txcfgl.com</p>
              <h4 style="color: #ff0000">特别提示：</h4>
              <p style="color: #ff0000">
                本风险揭示书的揭示事项仅为列举性质，未能详尽列明您接受证券投资顾问服务所面临的全部风险和可能导致您投资损失的所有因素。
              </p>
              <p style="color: #ff0000">
                您在接受证券投资顾问服务前，应认真阅读并理解相关业务规则、证券投资顾问服务协议及本风险揭示书的全部内容。
              </p>
              <p style="color: #ff0000">
                若您接受我公司证券投资顾问服务，您应自行承担投资风险，我公司不以任何方式向您作出不受损失或者取得最低收益的承诺。在任何情况下，我公司不能对您亏损承担责任或进行补偿。
              </p>
              <p style="color: #ff0000">
                我公司任何员工均无权从事受托理财、全权代理等类似业务，且不得因任何理由以个人账户收取证券投资顾问服务费用，请您不要与我公司员工签署任何形式的该类业务协议或接受任何形式的收益保证、利润分成承诺或向个人账户支付任何款项，否则您将自行承担相应的风险，我公司对任何此类协议和行为不承担责任。为了保护您的权益，如您发现我公司员工有上述行为，请立即向我公司反映。
              </p>
              <p style="color: #ff0000">
                您以书面、电子签名或勾选方式确认本风险揭示书即视为您已经理解并接受本风险揭示书所载的全部内容，并表明您愿意自行承担接受证券投资顾问服务的风险和可能产生的损失。
              </p>
              <p>客户签名：</p>
              <p>签署日期：</p>
            </el-tab-pane>
            <!-- <el-tab-pane label="软件许可协议">
              <div class="lis">
                <div class="box"></div>
                <h2>软件许可协议</h2>
              </div>
              <h4>证券投资顾问服务及相关软件许可使用协议</h4>
              <p>协议编号：</p>
              <p>甲方：北京天相财富管理顾问有限公司</p>
              <p>乙方：</p>
              <p>身份证号码：</p>
              <p>手机号：</p>
              <p>
                根据《中华人民共和国证券法》、《中华人民共和国合同法》、《证券、期货投资咨询管理暂行办法》和《证券投资顾问业务暂行规定》等相关法律法规，以及中国证券业协会（以下简称“证券业协会”）的有关自律规则，甲、乙双方本着平等自愿，诚实守信的原则，就甲方向乙方提供证券投资顾问服务及相关软件产品许可使用权(以下简称“投顾服务/产品”)事项，签订本协议，并共同遵守。
              </p>
              <h4>第一部分 证券投资顾问服务</h4>
              <p>第一章 声明与保证</p>
              <p>
                第一条
                甲方系国家证券主管机关核准的证券投资咨询专业机构；具备为投资者（客户）提供证券投资顾问服务的必要条件和专业能力。
              </p>
              <p>
                第二条
                甲方所提供的投顾服务/产品仅供乙方参考，乙方应自主作出投资决策，并独立承担投资风险。甲方不接受乙方的全权委托、不对乙方的投资收益或亏损进行任何形式的保证。不以任何形式代乙方作出投资决策。
              </p>
              <p>
                第三条
                甲方就乙方是否适合购买/接受本投顾服务/产品而做出的适当性匹配意见并不代表甲方对乙方购买/接受本投顾服务/产品的风险和收益做出实质性判断和保证。
              </p>
              <p>
                第四条
                乙方系证券市场合法投资者，具有签订及履行本协议义务所需的完全民事权利能力和完全民事行为能力。
              </p>
              <p>
                第五条
                乙方已仔细阅读并完全理解和认可甲方提供的《证券投资顾问业务风险揭示书》等相关合规风控文件；乙方已了解本协议的所有条款并准确理解其含义，乙方已理解投资可能需要承担的风险与提示，具有相应的风险承受能力，无论该风险为已有风险或潜在风险；已获知提供服务的投资顾问的姓名及登记编码。
              </p>
              <p>
                第六条
                乙方进行任何投资，包括其投资判断及决策，并不依赖于甲方或其员工提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务，而是在甲方的辅助下，经过深思熟虑作出独立判断及决策。乙方根据甲方证券投资顾问服务及软件工具、终端设备载体所提供的所有信息数据以及市场研究分析、投资建议等资料或产品所做出的决定和投资而造成的可能损失，由乙方自行承担，收益也自行享有。
              </p>
              <p>
                第七条
                甲、乙双方共同遵守国家的法律、法规，不利用本协议的关系从事任何违法、违规的行为。
              </p>
              <p>第二章 产品和服务信息</p>
              <p>
                第八条
                在本协议有效期内，甲方向乙方提供的投顾服务/产品内容具体包括：
              </p>
              <p>
                1、初始化服务：指甲方为乙方开设投顾服务/产品账户，授予相关软件产品的许可使用权，乙方在支付初始化费用后有权登录投顾服务/产品账户，下载、安装相关软件产品，并有权以本地化下载、存储的方式使用服务/产品中的历史数据。相关软件产品许可使用的具体条款，见本协议“第二部分
                软件许可使用”。
              </p>
              <p>
                2、产品/软件维护服务：指乙方开设投顾服务/产品账户，下载、安装甲方软件产品，成为甲方用户后，甲方在服务期内，为乙方提供市场研究分析报告、投资品种选择、投资策略、投资组合建议以及其他证券投资顾问产品等一项或若干项投资顾问服务，以及软件产品相关的技术支持、客服支持等服务。具体服务/产品名称、服务方式/渠道、提供时间和产品风险等级、适用客户等投顾服务/产品信息以乙方签约购买时该服务/产品页面展示的相关信息为准。甲方将依照本协议及具体该服务/产品页面展示信息的约定向乙方提供投顾服务/产品。
              </p>
              <p>本次乙方签约购买服务/产品的具体信息如下：</p>
              <p>1、 服务/产品名称：</p>
              <p>2、 服务/产品期限：</p>
              <p>3、 服务/产品费用：</p>
              <p>（1）初始化服务费：</p>
              <p>（2）产品/软件维护服务费：</p>
              <p>总支付服务费：</p>
              <p>
                4、产品/服务顾问及登记编码：
                ；该服务顾问为核心服务人员，为更好的提供服务，甲方采取团队化的服务方式，服务顾问团队成员亦协助服务顾问开展服务工作；乙方对此表示理解、接受与认可。
              </p>
              <p>
                第九条
                甲方向乙方提供服务采用如下方式：通过互联网、终端或软件、电话、短信、邮件、面对面咨询等方式。
              </p>
              <p>
                第十条服务/产品期限，以乙方购买时所选择服务期限为准。服务/产品到期后，客户有意继续购买的，需重新签署证券投资顾问服务及相关软件许可使用协议。
              </p>
              <p>
                第十一条
                服务费用和支付方式：乙方应于本协议签订时支付“初始化服务费”；自服务/产品启用之日起计算的服务期内支付“产品/软件维护服务费”。如甲方提供多个服务/产品，服务期将不做累加分别计算。“初始化服务费”以及“产品/软件维护服务费”的具体金额及支付方式以乙方购买服务/产品时甲方系统中标明的价格为准。乙方可在甲方提供的支付方式（包括第三方支付、网银、转账汇款等方式）中自行选择并支付上述费用。乙方将费用支付至甲方公司账户。
              </p>
              <p>
                如乙方在购买服务/产品时，甲方给予了优惠，乙方按照上述“总支付服务费”向甲方付款的，视为乙方已支付该服务/产品的全部费用，但甲方仅按照乙方实际支付的金额开具发票。
              </p>
              <p>
                双方确认，除本协议第五十二条约定的情形外，甲方收取的“初始化服务费”在任何情况下不退还。
              </p>
              <h4>第二部分 软件许可使用</h4>
              <p>第三章 软件产品许可使用</p>
              <p>第十二条 甲方许可乙方使用的软件产品为：</p>
              <p>（以下简称“本软件产品”）。</p>
              <p>
                第十三条
                乙方向甲方支付初始化服务费后，甲方授予乙方本软件产品的合法使用权，乙方有权下载、安装本软件产品，并有权以本地化下载、存储的方式使用本软件产品中的历史数据，并在软件下载、安装过程中得到甲方的技术、客服支持。
              </p>
              <p>第十四条 本软件产品的许可使用为非排他权利。</p>
              <p>
                第十五条
                本软件产品的许可使用期限自乙方启用本软件产品之日起计算。乙方的安装、使用行为将视为同意接受软件许可使用各项条款的约束。
              </p>
              <p>第四章 软件产品使用限制/p></p>
              <p>
                第十六条
                本软件产品之著作权及其他知识产权等相关权利或利益（包括但不限于现已取得或未来可取得之著作权、专利权、商标权等）皆为甲方所有。
              </p>
              <p>
                第十七条
                本软件产品受中华人民共和国版权法及国际版权条约和其他知识产权法及条约的保护。乙方仅获得本软件产品的非排他性使用权。
              </p>
              <p>第十八条 未经甲方事先书面同意，乙方不得实施以下行为：</p>
              <p>
                1、对本软件产品进行模仿、复制、修改、传播、转发或、提供给其他第三方或许可他人从事上述行为；
              </p>
              <p>
                2、将本软件产品用于除用户内部使用以外的其他目的，包括但不限于向第三方提供数据处理服务、应用服务、商业共享或其他软件共享安排；
              </p>
              <p>
                3、限制、破坏或绕过本软件产品附带的加密附件或甲方提供的其他确保本软件产品正确使用的限制性措施；
              </p>
              <p>
                4、除掉、掩盖或更改本软件产品上有关许可软件著作权或商标的标志。
              </p>
              <p>
                第十九条
                本软件产品以现状方式提供，甲方不保证本软件产品能够完全满足用户需求，在用户手册、帮助文件、使用说明书等软件文档中的介绍性内容仅供乙方参考，不得理解为对乙方所做的任何承诺。甲方保留对本软件产品版本进行升级，对功能、内容、结构、界面、运行方式等进行修改或自动更新的权利。
              </p>
              <p>第五章 软件产品升级</p>
              <p>
                第二十条
                如甲方对本软件产品功能进行优化或者增加了新的功能，视为对本软件产品进行了实质性的修改。实质性修改后的产品作为升级后的版本产品将被视为新产品，甲方对新产品拥有定价权。乙方有权选择是否购买新产品。若乙方放弃购买新产品，则乙方仍有权使用本软件产品。
              </p>
              <p>
                第二十一条
                若甲方对本软件产品进行非实质性的修改以保障其能够正常实现原有的功能和用途，乙方应无条件接受修改后的产品并承诺放弃使用未修改的产品。若乙方拒绝接受修改，将可能导致本软件产品无法正常使用，届时，将视为乙方主动放弃已经依据本软件产品许可使用各项条款所获得的一切权利。在此情况下，乙方缴纳的各种费用，甲方将不予退还。
              </p>
              <p>第六章 软件产品许可终止</p>
              <p>第二十二条 本软件产品许可在以下情况出现时终止：</p>
              <p>
                1、乙方未向甲方支付全部初始化服务费或甲方向乙方退还初始化服务费的；
              </p>
              <p>
                2、乙方未按照本协议的约定使用本软件产品或违反其在本软件产品许可使用各项条款项下其他约定的，甲方有权终止本软件产品许可使用授权并不退还任何费用。
              </p>
              <p>
                第二十三条
                自本软件产品许可使用授权终止之日起，甲方停止向乙方提供与本软件产品有关的全部服务。乙方需立即销毁本软件产品及其拷贝。如因乙方违约导致本软件产品许可使用授权终止的，甲方有权要求乙方承担违约责任并赔偿因违约对甲方造成的一切损失。
              </p>
              <p>第七章 甲方的权利和义务</p>
              <p>
                第二十四条
                甲方本着勤勉尽责、诚实守信的原则，为乙方提供专业、有偿服务。甲方应按照本协议约定向乙方提供软件产品，供乙方下载、安装、使用，保证乙方有权以本地化下载、存储的方式使用本软件产品中的历史数据，并在软件下载、安装过程中得到甲方的技术、客服支持。
              </p>
              <p>
                第二十五条
                甲方有权根据提供的证券投资咨询顾问服务、软件许可使用权和本协议约定收取初始化服务费和产品/软件维护服务费。
              </p>
              <p>
                第二十六条
                甲方享有所提供的证券投资顾问服务内容和本软件产品的知识产权及其他相关权利，未经甲方书面许可，乙方不得对甲方提供的服务内容进行模仿、复制、修改、传播、转发、提供给其他第三方或许可他人从事上述行为，亦不得实施本协议第十八条所列之行为，否则应当承担相应的违约责任。因乙方的前述行为给第三方造成的不利后果，甲方不承担任何责任；若甲方因此而承担责任的，甲方有权向乙方追偿。
              </p>
              <p>
                第二十七条
                甲方倡导理性投资，向乙方提供的证券投资顾问服务内容，仅供乙方参考，甲方不向乙方承诺证券投资收益。
              </p>
              <p>
                第二十八条
                甲方及其员工不代理乙方从事证券买卖或代替乙方做出投资决策，不得以任何形式对乙方的资金或资金账户进行直接或间接证券投资操作；不与乙方约定分享投资收益或者分担投资损失，也不以任何方式对乙方承诺或保证证券投资收益。
              </p>
              <p>
                第二十九条
                甲方所提供的证券投资顾问服务内容应当具有相关合理的依据并经科学、合理论证，无虚假、片面和误导性的陈述。投资建议的依据包括证券研究报告或者基于证券研究报告、理论模型以及分析方法形成的投资分析意见等。
              </p>
              <p>
                第三十条
                甲方向乙方提供证券投资顾问服务，忠实于乙方利益，不为自己买卖股票及具有股票性质、功能的证券以及期货；不利用咨询服务与他人合谋操作市场或者进行内幕交易；不得从事或协同他人从事欺诈、内幕交易、操纵证券交易价格等非法活动；不得编造、传播虚假信息或者误导投资者的信息；不得从事与其履行职责有利益冲突的业务；不得损害社会公共利益、他人的合法权益；不得从事中国证监会、证券业协会禁止的其他行为。
              </p>
              <p>
                第三十一条
                甲方依法保护因服务关系而知悉的有关乙方的财产状况及其个人隐私。
              </p>
              <p>第八章 乙方的权利与义务</p>
              <p>
                第三十二条
                在本协议有效期内，乙方有权按照本协议约定，接受甲方提供的市场研究分析报告、投资建议或相关信息、其他证券投资顾问服务以及软件许可使用权。未经甲方许可，擅自转让本协议项下权利和义务的，其转让行为对甲方不发生法律效力，由此造成的一切后果和责任均由乙方承担。
              </p>
              <p>
                第三十三条
                乙方应当全面、准确、及时地向甲方提供与接受证券投资顾问服务有关的各种信息和文件资料，并认真如实填写《客户投资风险承受能力评估表》，按国家规定披露自身身份、财产与收入状况、证券投资经验、投资风险承受能力等，并对所提供信息和资料的真实性、准确性和完整性负责，以便于甲方评估乙方的风险承受能力，但甲方的风险评估结论仅供参考。若乙方须提供的信息发生变化，应及时通知甲方，以便甲方作相应调整。
              </p>
              <p>
                第三十四条
                乙方应向甲方提供有效的联系方式和服务获取方式，如有变动须提前三个工作日书面通知甲方。若未及时告知联系方式及服务获取方式变动情况，或因乙方其他自身原因，或因不可抗力因素，导致乙方未能及时获得甲方提供的证券投资顾问服务，因此而产生的不利后果由乙方自行承担。
              </p>
              <p>
                第三十五条
                乙方有权决定是否采用甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务。乙方须基于独立判断、自行决定证券投资，自享投资收益、自行承担投资损失。
              </p>
              <p>
                第三十六条
                乙方应妥善保管证券账户、资金账户和相应的密码，不得委托甲方或者甲方的员工保管其账户、代理其买卖证券。乙方不得与甲方或者甲方的员工另行达成证券投资收益共享、损失分担的约定。
              </p>
              <p>
                第三十七条
                乙方不得将甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容泄露给任何第三人，如有违反，甲方有权提前终止本协议并追索由此而给甲方造成的经济损失。
              </p>
              <p>
                第三十八条
                乙方应根据本协议约定向甲方支付初始化服务费和产品/软件维护服务费。
              </p>
              <p>
                第三十九条
                乙方与甲方工作人员私自签订任何形式的协议，甲方不承担任何责任。
              </p>
              <p>第九章 保密条款</p>
              <p>
                第四十条
                甲方对因提供本协议约定的服务内容而知悉的乙方个人财产状况等其他个人资料负有保密义务，未经乙方事先书面许可，不得向第三方提供。但根据相关法律法规，在以下情形中，甲方可能会收集并使用乙方的个人信息，无需征得乙方同意：
              </p>
              <p>1、与国家安全、国防安全直接相关的；</p>
              <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
              <p>3、与犯罪侦查、起诉、审批、判决执行等直接相关的；</p>
              <p>
                4、出于维护乙方或他人的生命、财产等重大合法权益但又很难得到本人同意的；
              </p>
              <p>5、所收集的个人信息是乙方自行向社会公众公开的；</p>
              <p>
                6、从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；
              </p>
              <p>7、签订和履行本协议所必需的；</p>
              <p>
                8、用于维护所提供的服务的安全稳定运行所必须的，例如：发现、处置产品或服务的故障；
              </p>
              <p>9、法律法规规定的其他情形。</p>
              <p>
                第四十一条
                甲方因向乙方提供投资建议，知悉乙方做出具体投资决策的，不得向第三方泄露。
              </p>
              <p>
                第四十二条
                甲方因履行本协议而向乙方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容，乙方负有保密义务，未经甲方事先书面许可，不得向第三方提供。
              </p>
              <p>第十章 不可抗力</p>
              <p>
                第四十三条
                甲方尽力提供完整、及时、准确的信息，但不对所提供信息的完整性、及时性、准确性承担任何责任。
              </p>
              <p>
                第四十四条
                甲方全力保证信息的优质传输，但不对因任何原因造成的信息异常或信息传递异常情况所致后果承担任何责任。
              </p>
              <p>
                第四十五条
                对于甲方无法预测或无法控制的设备故障、通讯故障、政策法规规定、监管机构等政府机关要求、软件系统故障、黑客攻击、网络中断、病毒侵害、信息源异常及其它人力不可抗力而造成服务中断的情况，甲方不承担责任，但应尽快将发生不可抗力事故的情况通知乙方，并在乙方要求时提供有关证明文件。
              </p>
              <p>
                第四十六条
                除非甲乙双方特别约定，甲方对因任何未支付对价或免费/无偿使用投顾服务/产品的行为及用户不承担任何义务和责任，且甲方有权在不事先通知的情况下随时终止提供服务。
              </p>
              <p>第十一章 违约责任</p>
              <p>
                第四十七条
                甲方未能按本协议约定向乙方提供投顾服务/产品的，则乙方有权要求补齐服务期限与服务内容。
              </p>
              <p>
                第四十八条
                乙方未能按本协议约定支付服务/产品费用的，甲方有权暂停提供服务/产品，双方约定的服务期不予顺延。
              </p>
              <p>
                第四十九条
                若甲方有证据证明，乙方违反了本协议第二十六条或其他相关条款约定的，甲方有权终止本协议，不承担违约责任。甲方向乙方发出书面终止通知书后，协议终止，甲方无需向乙方退还任何费用，乙方应付费用甲方仍有权全额追收。
              </p>
              <p>
                第五十条
                乙方同意保障和维护甲方及其他客户的利益，如因乙方违反有关法律、法规或合同约定给甲方及其他客户造成损失的，乙方须承担赔偿责任。乙方对于本协议披露的所有关于服务的内容予以知悉、认可及接受，接受服务后不得对本协议约定的服务内容提出异议、进行投诉或进行任何追索，否则视为违约，甲方有权停止服务不承担违约责任，已收费用不予退还，给甲方造成损失的，甲方有权另行追偿。
              </p>
              <p>第十二章 协议的生效、变更和终止</p>
              <p>
                第五十一条
                本协议经双方电子或书面签名（盖章）确认，服务期满自行终止。经双方协商同意，本协议可提前终止，也可另行续签。
              </p>
              <p>
                第五十二条
                自签订本协议之日起5个工作日内，乙方可以书面通知方式提出解除协议。甲方收到乙方解除协议书面通知时，本协议解除。产品赠送部分在退款时不纳入退款金额折算。
              </p>
              <p>
                第五十三条
                本协议签署生效后，若有关法律、法规及行业规定已修订，本协议涉及内容及条款按新修订的法律法规执行，但其它内容及条款继续有效。如本协议与新的法律法规严重背离双方有义务在体现原协议要义的基础上修改本协议，或重新签署协议。
              </p>
              <p>第五十四条 甲乙双方经协商同意，可以修改本协议。</p>
              <p>
                第五十五条
                如发生甲方工作人员口头或书面承诺的内容超越本协议约定事项的，乙方不应当将此理解为本协议条款的补充或变更。
              </p>
              <p>第十三章 争议的解决</p>
              <p>
                第五十六条
                凡因执行本协议所发生的或与本协议有关的一切争议，甲乙双方应本着善意的原则通过友好协商解决。协商不成的，应提交北京仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。仲裁费由败诉方负担。
              </p>
              <p>
                第五十七条
                在争议处理过程中，除正在进行审理的部分外，协议的其它部分将继续执行，任何一方不得因发生争议故意损害或恶意诋毁另一方，不得威逼、利诱、恐吓对方，不得干扰和破坏对方的工作、学习和生活，如果违
                背本条款必须向对方赔付违约金。
              </p>
              <p>第十四章 附则</p>
              <p>
                第五十八条
                《证券投资顾问业务风险揭示书》为本协议附件，系本协议不可分割的组成部分，与本协议具有同等法律效力。凡与本协议有冲突之处，均以本协议约定为准。
              </p>
              <p>
                第五十九条
                本协议一式二份，甲乙双方各执一份，具有同等的法律效力。
              </p>
              <p>（以下无正文）</p>
              <p>
                （此页无正文，为《证券投资顾问服务及相关软件许可使用协议》之签章页）
              </p>
              <p>甲方盖章：</p>
              <p>签署日期：</p>
              <p>
                本人已认真阅读《证券投资顾问服务及相关软件许可使用协议》和《证券投资顾问业务风险揭示书》并同意签署。
              </p>
              <p>乙方签字：</p>
              <p>签署日期：</p>
            </el-tab-pane> -->
            <!-- <el-tab-pane label="投资顾问服务协议">
              <div class="lis">
                <div class="box"></div>
                <h2>投资顾问服务协议</h2>
              </div>
              <h4>北京天相财富管理顾问有限公司软件产品销售协议</h4>
              <p>协议编号:______________</p>
              <p>甲方：</p>
              <p>身份证号码：</p>
              <p>乙方：北京天相财富管理顾问有限公司</p>
              <p>注册地址：北京市西城区金融街19号B701D室</p>
              <p>
                根据《中华人民共和国证券法》、《中华人民共和国民法典》、《证券、期货投资咨询管理暂行办法》和《证券投资顾问业务暂行规定》等相关法律、法规，以及中国证券业协会（以下简称“证券业协会”）的有关自律规则，甲、乙双方本着公平、合理、自愿的原则，经友好协商就乙方向甲方提供证券投资咨询工具软件产品天相股多多软件（以下简称“本软件”）的使用许可事宜达成如下协议：
              </p>

              <p>第一章 双方声明</p>
              <p>
                第一条
                甲方系证券市场合法投资者，具有签订及履行本协议义务所需的完全民事权利能力和完全民事行为能力。
              </p>
              <p>
                第二条
                甲方已仔细阅读并完全理解和认可甲方提供的《证券投资顾问业务风险揭示书》等相关合规风控文件；乙方已了解本协议的所有条款并准确理解其含义，乙方已理解投资可能需要承担的风险与提示，具有相应的风险承受能力，无论该风险为已有风险或潜在风险。
              </p>
              <p>
                第三条
                甲方进行任何投资，包括其投资判断及决策，并不依赖于乙方或其员工提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务，而是在乙方的辅助下，经过深思熟虑作出独立判断及决策。甲方根据本软件所提供的所有信息数据以及市场研究分析、投资建议等资料或产品做出投资决定，并自行承担投资损失，享有投资收益。
              </p>
              <p>
                第四条
                乙方系具有中国证监会办法的证券投资者咨询业务资格（业务许可证号：91110102MA001GJE1N）的专业证券投资咨询公司；具备为投资者（客户）提供证券投资顾问服务的必要条件和专业能力。
              </p>
              <p>
                第五条
                乙方通过本软件提供的资讯仅供甲方参考，甲方应自主做出投资决策，并独立承担投资风险。乙方不代理甲方从事证券投资，不以任何方式向甲方保证投资收益或投资本金不受损失，不与甲方约定分享证券投资的收益或分担投资损失。
              </p>
              <p>
                第六条
                乙方就甲方是否适合购买/接受本软件产品而做出的适当性匹配意见并不代表乙方对甲方购买/接受本软件产品的风险和收益作出实质性判断和保证。
              </p>
              <p>
                第七条
                甲、乙双方共同遵守国家的法律、法规，不利用本协议的关系从事任何违法、违规行为。
              </p>
              <p>第二章 软件产品、收费标准和收费方式</p>
              <p>第八条 甲方所购买的乙方软件产品是天相股多多软件V1.0.0。</p>
              <p>□ 寻龙版</p>
              <p>□ 大师版</p>
              <p>
                第九条
                甲乙双方商定，甲方应向乙方一次性支付上述软件产品总价款共计人民币元整（￥
                ），其中包括软件初次初始化费用人民币
                元（￥______），软件使用费人民币 元（￥______
                ）。双方约定，除本协议第四十九条约定的情形外，乙方收取的“初始化费用”在任何情况下不退还。
              </p>
              <p>
                如甲方在购买产品时，乙方给予了优惠，甲方按照上述“总价款”向乙方付款的，视为甲方已支付该产品的全部费用，但乙方仅按照甲方实际支付的金额开具发票。
              </p>
              <p>第十一条 产品使用期限自服务开通之日起计算，服务期限__天。</p>
              <p>第三章 软件产品使用限制</p>
              <p>
                第十二条
                本软件产品之著作权及其他知识产权等相关权利或利益（包括但不限于现已取得或未来可取得之著作权、专利权、商标权等）皆为乙方所有。
              </p>
              <p>
                第十三条
                本软件产品受中华人民共和国版权法及国际版权条约和其他知识产权法及条约的保护。甲方仅获得本软件产品的非排他性使用权。
              </p>
              <p>第十四条 未经乙方事先书面同意，甲方不得实施以下行为：</p>
              <p>
                1、对本软件产品进行模仿、复制、修改、传播、转发或、提供给其他第三方或许可他人从事上述行为；
              </p>
              <p>
                2、将本软件产品用于除用户内部使用以外的其他目的，包括但不限于向第三方提供数据处理服务、应用服务、商业共享或其他软件共享安排；
              </p>
              <p>
                3、限制、破坏或绕过本软件产品附带的加密附件或乙方提供的其他确保本软件产品正确使用的限制性措施；
              </p>
              <p>
                4、删除、掩盖或更改本软件产品上有关许可软件著作权或商标的标志。
              </p>
              <p>
                第十五条
                本软件产品以现状方式提供，乙方不保证本软件产品能够完全满足用户需求，在用户手册、帮助文件、使用说明书等软件文档中的介绍性内容仅供甲方参考，不得理解为对甲方所做的任何承诺。乙方保留对本软件产品版本进行升级，对功能、内容、结构、界面、运行方式等进行修改或自动更新的权利。
              </p>
              <p>第四章 软件产品升级</p>
              <p>
                第十六条
                如乙方对本软件产品功能进行优化或者增加了新的功能，视为对本软件产品进行了实质性的修改。实质性修改后的产品作为升级后的版本产品将被视为新产品，乙方对新产品拥有定价权。甲方有权选择是否购买新产品。若甲方放弃购买新产品，则甲方仍有权使用本软件产品。/p>
              </p>
              <p>
                第十七条
                若乙方对本软件产品进行非实质性的修改以保障其能够正常实现原有的功能和用途，甲方应无条件接受修改后的产品并承诺放弃使用未修改的产品。若甲方拒绝接受修改，将可能导致本软件产品无法正常使用，届时，将视为甲方主动放弃已经依据本软件产品许可使用各项条款所获得的一切权利。在此情况下，甲方缴纳的各种费用，乙方将不予退还。
              </p>
              <p>第五章软件产品许可终止</p>
              <p>第十八条 本软件产品许可在以下情况出现时终止：</p>
              <p>
                1、甲方未向乙方支付软件产品费用或甲方向乙方退还初始化费用的；
              </p>
              <p>
                2、甲方未按照本协议的约定使用本软件产品或违反其在本软件产品许可使用各项条款项下其他约定的，乙方有权终止本软件产品许可使用授权并不退还任何费用。
              </p>
              <p>
                第十九条
                自本软件产品许可使用授权终止之日起，乙方停止向甲方提供本软件产品及有关的全部服务。甲方需立即销毁本软件产品及其拷贝。如因甲方违约导致本软件产品许可使用授权终止的，乙方有权要求甲方承担违约责任并赔偿因违约对乙方造成的一切损失。
              </p>
              <p>第六章 甲方的权利与义务</p>
              <p>
                第二十条
                甲方成为乙方授权使用的客户，甲方有权按照本协议约定，获得本软件许可使用权，接受乙方提供的市场研究分析报告、投资建议或相关信息等其他证券投资顾问服务。未经乙方许可，擅自转让本协议项下权利和义务的，其转让行为对乙方不发生法律效力，由此造成的一切后果和责任均由甲方承担。
              </p>
              <p>
                第二十一条
                甲方有权决定是否采用乙方以软件为载体提供的咨询意见和投资建议。甲方须基于独立判断、自行决定证券投资，自享投资收益、自行承担投资损失。
              </p>
              <p>
                第二十二条
                甲方应认真填写《客户信息登记表》和《客户投资风险承受能力评估表》，按国家规定披露自身身份、财产与收入状况、证券投资经验、投资风险承受能力等，并对所提供信息和资料的真实性、准确性和完整性负责，以便于乙方评估甲方的风险承受能力，但乙方的风险评估结论仅供参考。若甲方须提供的信息发生变化，应及时通知乙方，以便乙方作相应调整。
              </p>
              <p>
                第二十三条
                甲方应向乙方提供有效的联系方式和服务获取方式，如有变动须提前三个工作日书面通知乙方。若未及时告知联系方式及服务获取方式变动情况，或因甲方其他自身原因，或因不可抗力因素，导致甲方未能及时获得乙方提供的证券投资顾问服务，因此而产生的不利后果由甲方自行承担。
              </p>
              <p>
                第二十四条
                甲方应妥善保管乙方提供的软件产品用户账号和密码，甲方因个人原因导致用户账号和密码泄露造成经济损失的，乙方不承担责任。
              </p>
              <p>
                第二十五条
                甲方应妥善保管甲方的证券账户、资金账户和相应的密码，不得委托乙方、乙方员工管理甲方证券账户，代理买卖证券，或者与乙方、乙方员工另行签订证券投资收益保证、收益共享或损失分担的协议或者达成约定。
              </p>
              <p>
                第二十六条
                甲方不得将乙方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容泄露给任何第三人，如有违反，乙方有权提前终止本协议并追索由此而给乙方造成的经济损失。
              </p>
              <p>
                第二十七条
                甲方应在工作时间通过乙方的工作电话座机、企业微信方式与乙方员工沟通。甲方与乙方员工的个人手机通话或发送短信属甲方与乙方员工个人行为，不属于乙方应提供的服务，也不属于乙方责任范围，由此引发的一切后果乙方不承担责任。
              </p>
              <p>
                第二十八条
                甲方应根据本协议约定向乙方指定的公司账户支付软件产品费用。
              </p>
              <p>第七章 乙方的权利和义务</p>
              <p>
                第二十九条
                乙方授予甲方本软件产品的非专有合法使用权。乙方应按照本协议约定向甲方提供软件产品，供甲方下载、安装、使用，保证甲方有权以本地化下载、存储的方式使用本软件产品中的历史数据，并在软件下载、安装过程中得到乙方的技术、客服支持。
              </p>
              <p>
                第三十条
                乙方以软件为载体向甲方提供投资建议和服务，辅助客户作出投资决策，仅供甲方参考。乙方所提供的投资建议应当具有相关合理的依据，无虚假、不实和误导性的陈述。投资建议的依据包括证券研究报告或者基于证券研究报告、理论模型、算法模型以及分析方法形成的投资分析意见等。
              </p>
              <p>
                第三十一条
                乙方享有所提供软件产品的知识产权，未经乙方书面许可，甲方不得对乙方提供的服务内容进行模仿、复制、修改、传播、转发、提供给其他第三方或许可他人从事上述行为，亦不得实施本协议第十四条所列之行为，否则应当承担相应的违约责任。因甲方的前述行为给第三方造成的不利后果，乙方不承担任何责任；若乙方因此而承担责任的，乙方有权向甲方追偿。
              </p>
              <p>
                第三十二条
                乙方及其员工不代理甲方从事证券买卖或代替甲方作出投资决策，不得以任何形式对甲方的资金或资金账户进行直接或间接证券投资操作，不与甲方约定分享甲方证券投资的收益或分担损失，或者向甲方承诺证券投资收益。在任何情况下，乙方不会对甲方的投资亏损承担责任或进行补偿。
              </p>
              <p>
                第三十三条
                乙方不允许乙方员工在工作时间及非工作时间用个人手机与客户通话或发送短信，如有此行为属乙方员工个人行为，不属于乙方应提供的服务，也不属于乙方责任范围，由此引发的一切后果乙方不承担责任。
              </p>
              <p>第三十四条 乙方有权根据本协议约定收取软件产品费用。</p>
              <p>第八章保密条款</p>
              <p>
                第三十五条
                乙方对因提供本协议约定的内容而知悉的甲方个人财产状况等其他个人资料负有保密义务，未经甲方事先书面许可，不得向第三方提供。但根据相关法律法规，在以下情形中，乙方可能会收集并使用甲方的个人信息，无须征得甲方同意：
              </p>
              <p>1、与国家安全、国防安全直接相关的；</p>
              <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
              <p>3、与犯罪侦查、起诉、审批、判决执行等直接相关的；</p>
              <p>
                4、出于维护乙方或他人的生命、财产等重大合法权益但又很难得到本人同意的；
              </p>
              <p>5、所收集的个人信息是乙方自行向社会公众公开的；</p>
              <p>
                6、从合法公开披露的信息中收集个人信息，例如：合法的新闻报道、政府信息公开等渠道；
              </p>
              <p>7、签订和履行本协议所必需的；</p>
              <p>
                8、用于维护所提供的服务的安全稳定运行所必须的，例如：发现、处置产品或服务的故障；
              </p>
              <p>9、法律法规规定的其他情形。</p>
              <p>
                第三十六条
                乙方因向甲方提供投资建议，知悉甲方做出具体投资决策的，不得向第三方泄露。
              </p>
              <p>
                第三十七条
                乙方因履行本协议而向甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容，甲方负有保密义务，未经乙方事先书面许可，不得向第三方提供。
              </p>
              <p>第九章 不可抗力</p>
              <p>
                第三十八条
                乙方尽力提供完整、及时、准确的信息，但不对所提供信息的完整性、及时性、准确性承担任何责任。
              </p>
              <p>
                第三十九条
                乙方全力保证信息的优质传输，但不对因任何原因造成的信息异常或信息传递异常情况所致后果承担任何责任。
              </p>
              <p>
                第四十条
                对于乙方因火灾、地震、瘟疫、社会动乱等不能预见、避免或克服的不可抗力情形，或因出现无法预测或无法控制的软件系统故障、设备故障、通讯故障、电力故障、黑客攻击、网络中断、病毒侵害、信息源异常等异常事故，或因本协议生效后新颁布、实施或修改的法律、法规、规章或政策等因素而造成服务中断的情况，乙方不承担责任，但应尽快将发生不可抗力事故的情况通知甲方，并在甲方要求时提供有关证明文件。
              </p>
              <p>
                第四十一条
                除非甲乙双方特别约定，乙方对因任何未支付对价或免费/无偿使用本软件产品的行为及用户不承担任何义务和责任，且乙方有权在不事先通知的情况下随时终止提供服务。/p>
              </p>
              <p>第十章 违约责任</p>
              <p>
                第四十二条
                乙方未能按本协议约定向甲方提供本软件产品的，则甲方有权要求补齐服务期限与服务内容。
              </p>
              <p>
                第四十三条
                甲方未能按本协议约定支付软件使用费用的，乙方有权暂停提供软件使用权，双方约定的服务期不予顺延。
              </p>
              <p>
                第四十四条
                若乙方有证据证明，甲方违反了本协议第三十一条或其他相关条款约定的，乙方有权终止本协议。乙方向甲方发出书面终止通知书后，协议终止，乙方无需向甲方退还任何费用，甲方应付费用乙方仍有权全额追收。
              </p>
              <p>
                第四十五条
                甲方同意保障和维护乙方及其他客户的利益，如因甲方违反有关法律、法规或合同约定给乙方及其他客户造成损失的，甲方须承担赔偿责任。
              </p>
              <p>第十一章　争议解决</p>
              <p>
                第四十六条
                凡因执行本协议所发生的或与本协议有关的一切争议，甲乙双方应本着善意的原则通过友好协商解决。协商不成的，应提交北京仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。仲裁费由败诉方负担。
              </p>
              <p>
                第四十七条
                在争议处理过程中，除正在进行审理的部分外，协议的其它部分将继续执行，任何一方不得因发生争议故意损害或恶意诋毁另一方，不得威逼、利诱、恐吓对方，不得干扰和破坏对方的工作、学习和生活，如果违背本条款应向对方赔付双倍于本协议服务费用的违约金。
              </p>
              <p>第十二章 协议的变更与终止</p>
              <p>
                第四十八条
                本协议经双方电子或书面签名（盖章）确认，服务期满自行终止。经双方协商同意，本协议可提前终止，也可另行续签。
              </p>
              <p>
                第四十九条
                自签订本协议之日起5个工作日内，甲方可以书面通知方式提出解除协议。乙方收到甲方解除协议书面通知时，本协议解除。产品赠送部分在退款时不纳入退款金额折算。
              </p>
              <p>
                第五十条
                本协议签署生效后，若有关法律、法规及行业规定已修订，本协议涉及内容及条款按新修订的法律法规执行，但其它内容及条款继续有效。如本协议与新的法律法规严重背离双方有义务在体现原协议要义的基础上修改本协议，或重新签署协议。
              </p>
              <p>
                第五十一条
                本协议内容涂改无效，如确有更改或补充需要，须甲乙双方经协商一致，另以附件形式为之。
              </p>
              <p>
                第五十二条
                如发生乙方工作人员口头或书面承诺的内容超越本协议约定事项的，甲方不应当将其理解为本协议条款的补充或变更。
              </p>
              <p>第十三章 附则</p>
              <p>
                第五十三条
                《证券投资顾问业务风险揭示书》为本协议附件，系本协议不可分割的组成部分，与本协议具有同等法律效力。凡与本协议有冲突之处，均以本协议约定为准。
              </p>
              <p>
                第五十四条
                本协议一式贰份，甲乙双方各执一份，具有同等的法律效力。
              </p>
              <p>
                本人已认真阅读《北京天相财富管理顾问有限公司软件产品销售协议》和《证券投资顾问业务风险揭示书》并完全理解本协议及其附件的全部条款，充分知悉、理解本协议项下的权利、义务和责任，对上述全部条款约定的内容没有异议，自愿签订本协议并自行承担投资损失，享受投资收益。
              </p>
              <p>
                甲方：
                <span style="margin-left: 360px"
                  >乙方：北京天相财富管理顾问有限公司</span
                >
              </p>
              <p>
                签字（盖章）：
                <span style="margin-left: 300px"> 签字（盖章）：</span>
              </p>
              <p>
                签约日期：____年___月___日
                <span style="margin-left: 210px">
                  签约日期：____年___月___日</span
                >
              </p>
            </el-tab-pane> -->
            <el-tab-pane label="收款公示">
              <div class="lis">
                <div class="box"></div>
                <h2>收款公示</h2>
              </div>
              <p>尊敬的投资者，您好!</p>
              <p>
                北京天相财富管理顾问有限公司
                指定收款渠道公示如下，请各位投资者注意：
              </p>
              <p style="color: red">
                温馨提示：以下公司账号均为对公账号，其他任何私人账号均为假冒，请投资者注意。
              </p>

              <div class="gongshi">
                <div class="weixin">
                  <img src="../assets/img/userService/111111.jpg" alt="" />
                  <p>微信账户名：北京天相财富管理顾问有限公司</p>
                </div>
                <div class="zfb">
                  <img src="../assets/img/userService/2222222.jpg" alt="" />
                  <p>支付宝账号：txcfzfb@txcfgl.com</p>
                  <p>支付宝账户名：北京天相财富管理顾问有限公司</p>
                </div>
                <div class="yinlian">
                  <img src="../assets/img/userService/h2-3.png" alt="" />
                  <p>建设银行</p>
                  <p>账户名称：北京天相财富管理顾问有限公司</p>
                  <p>开户银行：中国建设银行北京月坛支行</p>
                  <p>银行账号：11050190360000000075</p>
                </div>
              </div>

              <p>公示账号①</p>
              <!-- <img src="../assets/img/userService/h2-2.png" alt="">
              <img src="../assets/img/userService/h2-3.png" alt=""> -->
              <p>银行账号：11050190360000000075</p>
              <p>开户银行：中国建设银行北京月坛支行</p>
              <p>账户名：北京天相财富管理顾问有限公司</p>
              <p>公示账号②</p>
              <!-- <img src="../assets/img/userService/h2-2.png" alt="">
              <img src="../assets/img/userService/h2-3.png" alt=""> -->
              <p>银行账号：110926413710202</p>
              <p>开户银行：招商银行北京金融街支行</p>
              <p>账户名：北京天相财富管理顾问有限公司</p>
              <p>公示账号③</p>
              <!-- <img src="../assets/img/userService/h2-2.png" alt="">
              <img src="../assets/img/userService/h2-3.png" alt=""> -->
              <p>银行账号：0200213319200026467</p>
              <p>开户银行：中国工商银行北京阜成门支行</p>
              <p>账户名：北京天相财富管理顾问有限公司</p>
              <p>公示账号④</p>
              <!-- <img src="../assets/img/userService/h2-2.png" alt="">
              <img src="../assets/img/userService/h2-3.png" alt=""> -->
              <p>银行账号：11020101040013932</p>
              <p>开户银行：中国农业银行北京金融大街支行</p>
              <p>账户名：北京天相财富管理顾问有限公司</p>
            </el-tab-pane>
            <el-tab-pane label="风险承受能力评估表">
              <div class="lis">
                <div class="box"></div>
                <h2>风险承受能力评估表</h2>
              </div>
              <p>投资者姓名：</p>
              <p>账号：</p>
              <p>
                本问卷旨在了解您可承受的风险程度等情况，借此协助您选择合适的产品或服务类别，以符合您的风险承受能力。
              </p>
              <p>
                风险承受能力评估是本公司向投资者履行适当性义务的一个环节，其目的是使本公司所提供的产品或服务与您的风险承受能力等级相匹配。
              </p>
              <p>
                本公司特别提醒您：本公司向投资者履行风险承受能力评估等适当性义务，并不能取代您自己的投资判断，也不会降低产品或服务的固有风险。同时，与产品或服务相关的投资风险、履约责任以及费用等将由您自行承担。
              </p>
              <p>
                本公司提示您：本公司根据您提供的信息对您进行风险承受能力评估，履行适当性义务。
              </p>
              <p>
                本公司建议：当您的各项状况发生重大变化时，需对您所投资的产品及时进行重新审视，以确保您的投资决定与您可承受的投资风险程度等实际情况一致。
              </p>
              <p>
                公司在此承诺，对于您在本问卷中所提供的一切信息，本公司将严格按照法律法规要求承担保密义务。除法律法规规定的有权机关依法定程序进行查询以外，本公司保证不会将涉及您的任何信息提供、泄露给任何第三方，或者将相关信息用于违法、不当用途。
              </p>
              <h4>一、 财务状况</h4>
              <p>1、您的主要收入来源是：</p>
              <p>A．工资、劳务报酬</p>
              <p>B．生产经营所得</p>
              <p>C．利息、股息、转让证券等金融性资产收入</p>
              <p>D．出租、出售房地产等非金融性资产收入</p>
              <p>E．无固定收入</p>
              <p>
                2、
                最近您家庭预计进行证券投资的资金占家庭现有总资产(不含自住、自用房产及汽车等固定资产)的比例是：
              </p>
              <p>A．70%以上</p>
              <p>B．50%-70%</p>
              <p>C．30%－50%</p>
              <p>D．10%－30%</p>
              <p>E． 10%以下</p>
              <p>3、您是否有尚未清偿的数额较大的债务，如有，其性质是：</p>
              <p>A．没有</p>
              <p>B．有，住房抵押贷款等长期定额债务</p>
              <p>C．有，信用卡欠款、消费信贷等短期信用债务</p>
              <p>D．有，亲朋之间借款</p>
              <p>4、您可用于投资的资产数额（包括金融资产和不动产）为</p>
              <p>A． 不超过50万元人民币</p>
              <p>B． 50万-300万元（不含）人民币</p>
              <p>C． 300万-1000万元（不含）人民币</p>
              <p>D．1000万元人民币以上</p>
              <h4>二、投资知识</h4>
              <p>5、 以下描述中何种符合您的实际情况：</p>
              <p>
                A．
                现在或此前曾从事金融、经济或财会等与金融产品投资相关的工作超过两年
              </p>
              <p>
                B． 已取得金融、经济或财会等与金融产品投资相关专业学士以上学位
              </p>
              <p>
                C．
                取得证券从业资格、基金从业资格、期货从业资格、注册会计师证书（CPA）或注册金融分析师证书（CFA）中的一项及以上
              </p>
              <p>D．我不符合以上任何一项描述</p>
              <h4>三、 投资经验</h4>
              <p>6、您的投资经验可以被概括为：</p>
              <p>A．有限：除银行活期账户和定期存款外，我基本没有其他投资经验</p>
              <p>
                B．一般：除银行活期账户和定期存款外，我购买过基金、保险等理财产品，但还需要进一步的指导
              </p>
              <p>
                C．丰富：我是一位有经验的投资者，参与过股票、基金等产品的交易，并倾向于自己做出投资决策
              </p>
              <p>
                D．非常丰富：我是一位非常有经验的投资者，参与过权证、期货或创业板等产品的交易
              </p>
              <p>
                7、
                有一位投资者一个月内做了15笔交易（同一品种买卖各一次算一笔），您认为这样的交易频率：
              </p>
              <p>A． 太高了</p>
              <p>B． 偏高</p>
              <p>C． 正常</p>
              <p>D．偏低</p>
              <p>
                8、
                过去一年时间内，您购买的不同产品或接受的不同服务（含同一类型的不同产品或服务）的数量是：
              </p>
              <p>A． 5个以下</p>
              <p>B． 6至10个</p>
              <p>C． 11至15个</p>
              <p>D．16个以上</p>
              <p>9、 以下金融产品或服务，您投资经验在两年以上的有：</p>
              <p>A． 银行存款等</p>
              <p>B． 债券、货币市场基金、债券型基金或其它固定收益类产品等</p>
              <p>
                C． 股票、混合型基金、偏股型基金、股票型基金等权益类投资品种等
              </p>
              <p>D．期货、期权、融资融券</p>
              <p>E．复杂金融产品、其他产品或服务</p>
              <p>（注：本题可多选，但评分以其中最高分值选项为准。）</p>
              <p>
                10、
                如果您曾经从事过金融市场投资，在交易较为活跃的月份，平均月交易额大概是多少：
              </p>
              <p>A． 10万元以内</p>
              <p>B． 10万元-30万元</p>
              <p>C． 30万元-100万元</p>
              <p>D．100万元以上</p>
              <p>E．从未从事过金融市场投资</p>
              <h4>四、投资目标</h4>
              <p>11、 您用于证券投资的大部分资金不会用作其它用途的时间段为：</p>
              <p>A．0到1年</p>
              <p>B．1到5年</p>
              <p>C．无特别要求</p>
              <p>12、 您打算重点投资于哪些种类的投资品种？</p>
              <p>A． 债券、货币市场基金、债券基金等固定收益类投资品种</p>
              <p>
                B． 股票、混合型基金、偏股型基金、股票型基金等权益类投资品种
              </p>
              <p>C． 期货、期权、融资融券等</p>
              <p>D．高风险金融产品或服务</p>
              <p>E．其他产品或服务</p>
              <p>（注：本题可多选，但评分以其中最高分值选项为准。）</p>
              <p>
                13、
                假设有两种不同的投资：投资A期望获得5%的收益，有可能承担非常小的损失；投资B期望获得20%的收益，但有可能面临25%甚至更高的亏损。您将您的投资资产分配为：
              </p>
              <p>A．全部投资于A</p>
              <p>B．大部分投资于A</p>
              <p>C．两种投资各一半</p>
              <p>D．大部分投资于B</p>
              <p>E．全部投资于B</p>
              <p>14、 当您进行投资时，您的期望收益是：</p>
              <p>A．尽可能保证本金安全，不在乎收益率比较低</p>
              <p>B．产生一定的收益，可以承担一定的投资风险</p>
              <p>C．产生较多的收益，可以承担较大的投资风险</p>
              <p>D．实现资产大幅增长，愿意承担很大的投资风险</p>
              <h4>五、风险偏好</h4>
              <p>15、 您认为自己能承受的最大投资损失是多少？</p>
              <p>A． 不能承受任何损失</p>
              <p>B． 一定的投资损失</p>
              <p>C． 较大的投资损失</p>
              <p>D．损失可能超过本金</p>
              <p>16、您打算将自己的投资回报主要用于：</p>
              <p>A． 改善生活</p>
              <p>B． 个体生产经营或证券投资以外的投资行为</p>
              <p>C． 履行扶养、抚养或赡养义务</p>
              <p>D．本人养老或医疗</p>
              <p>E．偿付债务</p>
              <h4>六、其他信息</h4>
              <p>17、您的年龄是：</p>
              <p>A． 18-30岁</p>
              <p>B． 31-40岁</p>
              <p>C． 41-50岁</p>
              <p>D 51-60岁</p>
              <p>E．超过60岁</p>
              <p>
                18、
                今后五年时间内，您的父母、配偶以及未成年子女等需负法定抚养、扶养和赡养义务的人数为：
              </p>
              <p>A． 1-2人</p>
              <p>B． 3-4人</p>
              <p>C． 5人以上</p>
              <p>19、 您的最高学历是：</p>
              <p>A． 高中或以下</p>
              <p>B． 大学专科</p>
              <p>C． 大学本科</p>
              <p>D．硕士及以上</p>
              <p>20、 您家庭的就业状况是：</p>
              <p>A． 您与配偶均有稳定收入的工作</p>
              <p>B． 您与配偶其中一人有稳定收入的工作</p>
              <p>C． 您与配偶均没有稳定收入的工作或者已退休</p>
              <p>D．未婚，但有稳定收入的工作</p>
              <p>E．未婚，目前暂无稳定收入的工作</p>
              <h4>投资者签署确认</h4>
              <p>
                本人已经了解并愿意遵守国家有关证券市场管理的法律、法规、规章及相关业务规则，本人在此郑重承诺以上填写的内容真实、准确、完整并对其负责。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。
              </p>
              <p>投资者（签名）：</p>
              <p>签署日期：</p>
            </el-tab-pane>
            <el-tab-pane label="投诉及处理流程">
              <div class="lis">
                <div class="box"></div>
                <h2>投诉及处理流程</h2>
              </div>
              <p>尊敬的客户：</p>
              <p>
                感谢您的厚爱！您的宝贵意见和建议将使我们的服务得到进一步改善，我们会尽快与您沟通反馈
              </p>
              <h4>处理流程：</h4>
              <img
                style="margin-left: 30px"
                src="../assets/img/userService/h2-4.png"
                alt=""
              />
            </el-tab-pane>

            <el-tab-pane label="常见问题">
              <div class="lis">
                <div class="box"></div>
                <h2>常见问题</h2>
              </div>
              <p>问：服务权限何时开通?</p>
              <p>
                答：根据《投资顾问服务业务暂行规定》，双方合同需要签署正式协议并从协议生效日起提供服务。您确认订单后，我公司会为您提供《风险承受能力评估表》、《风险揭示书》
                及《服务协议》三份电子协议，请您检查产品以及个人信息无误后，网上签名确认合同
              </p>
              <p>问：天相财富个人软件决策服务是否受到区域限制?</p>
              <p>
                答：天相财富个人软件决策服务，大部分是通过互联网、移动互联网和手机通信实现的，没有地域的限制。
              </p>
              <p>问：使用产品遇问题向谁求助?</p>
              <p>
                答：在您使用购买软件产品后，如遇到任何使用问题，可直接致电售后服务中心
                010-66045050 我们的售后服务人员会耐心为您解答问题。
              </p>
              <p>问：我想更换手机号码怎么办?</p>
              <p>
                答：如果您想更换手机号码等联系方式，请联系我们的客服进行更改。
              </p>
              <p>问：为什么要进行风险承受能力测试?</p>
              <p>
                答：根据您目前真实信息进行风险承受能力测试，可以比较客观地了解您的风险承受能力，从而有助于我们为您提供适当的服务。如果在续费或者升级产品服务前，您的情况有所变更，请您在产品个人中心或者致电客服，更新您的《风险承受能力评估表》
              </p>
            </el-tab-pane>
            <!-- <el-tab-pane label="天相股票证券辅助决策系统">
              <div class="lis">
                <div class="box"></div>
                <h2>天相股票证券辅助决策系统</h2>
              </div>
              <div class="btn" >天相股票用户使用手册</div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
      <div class="h3">
        <div class="w">
          <div class="lis1">经营证券期货业务许可证公示</div>
          <div class="lis2">
            <div class="l">
              <img src="../assets/img/userService/csrc.png" alt="" />
              <div class="right">
                <!-- 91110102MA001GJE1N -->
                <div class="p1">
                  经营证券期货业务许可证 统一社会信用代码：91110102MA001GJE1N
                </div>
                <div class="p1">
                  从事证劵投资或期货交易，请通过合法证券期货经营机构进行，合法机构名单可到中国证监会
                  网站（www.csrc.gov.cn）查询。 投资有风险，入市需谨慎！
                </div>
              </div>
            </div>
            <div class="r">
              <div class="p1" style="margin-bottom: 10px">
                咨询电话：010-66045050
              </div>
              <div class="p2">申诉电话：400-101-8662</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Headers from "../components/headers";
import Bottom from "../components/bottom";
export default {
  name: "userService",
  components: {
    Headers,
    Bottom,
  },
  data() {
    return {
      tabPosition: "left",
    };
  },
  methods: {
    handleClick(tab, event) {},
    toDetail() {
      window.open(
        "https://img.cdn.dn8188.com/dn8188/%E6%87%82%E7%89%9B%E8%82%A1%E7%A5%A8%E7%94%A8%E6%88%B7%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf"
      );
    },
  },
};
</script>
<style>
.gongshi {
  width: 100%;
  height: 700px;

  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 50px;
}
.weixin img {
  border: 2px solid #ccc;
  width: 160px;
  height: 220px;
}
.zfb img {
  border: 2px solid #ccc;
  width: 160px;
  height: 220px;
}
.gongshi p {
  margin: 10px 0;
}
.weixin,
.zfb,
.yinlian {
  margin-bottom: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.h2 .el-tabs__nav-wrap::after {
  height: 1px;
}
.h2 .el-tabs__item {
  width: 285px;
  height: 89px;
  font-size: 20px;
  background-color: #fff;
  font-weight: 400;
  color: #333;
  border-bottom: 2px solid #fff;

  line-height: 89px;
}
.h2 .el-tabs__item:hover {
  color: #fff;
  background-color: #d5352e;
}
.h2 .el-tabs__item.is-active {
  color: #fff;
  background-color: #d5352e;
}
.h2 .el-tabs__active-bar {
  background: #d5352e;
  /* width: 30px; */
}
</style>

<style lang="less" scoped>
.btn {
  width: 250px;
  height: 80px;
  background-color: #df2424;
  color: #fff;
  text-align: center;
  line-height: 80px;
  border-radius: 5px;
}
p {
  text-indent: 2em;
  line-height: 1.8;
  color: #555;
}
.h1 {
  width: 100%;
  height: 300px;
  background: url(../assets/img/userService/h1-1.jpg) no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.h2 {
  background-color: #f0f0f0;
  padding-top: 69px;
  padding-bottom: 50px;
  .w {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    .el-tab-pane {
      background-color: #fff;
      padding: 20px;
      .lis {
        display: flex;
        align-items: center;

        .box {
          width: 3px;
          height: 40px;
          background-color: #d5352e;
          margin-right: 18px;
          h2 {
            font-size: 28px;
            color: #222222;
          }
        }
      }
      p {
      }
    }
  }
}
.h3 {
  width: 100%;
  height: 245px;
  background-color: #fff;
  .w {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .lis1 {
      padding: 38px 0;
      color: #555555;
      font-size: 14px;
    }
    .lis2 {
      display: flex;
      align-items: center;
      .l {
        width: 960px;
        height: 100px;
        border: 1px solid #dddddd;
        display: flex;
        align-items: center;

        img {
          padding-left: 20px;
          width: 51px;
          height: 57px;
        }
        .right {
          margin-left: 30px;
          font-size: 14px;
          color: #555555;
          width: 780px;
        }
      }
      .r {
        margin-left: 15px;
        font-size: 15px;
        color: #555555;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/userService.vue